export enum EnemyState {
    None = -1,
    Dead = 0,
    Idle = 1,
    MoveToTargetPosition = 2,
    MoveToTargetEntity = 3,
    Attack = 4
}